<template>
	<div :class="$style['settings-switch-field']">
		<div :class="$style['settings-switch-field__content']">
			<strong :class="$style['settings-switch-field__label']">
				{{ labelText }}
			</strong>
			<span v-if="hintText" :class="$style['settings-switch-field__hint']">
				{{ hintText }}
			</span>
		</div>
		<BaseSwitch
			:value="value"
			:disabled="disabled"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
export default {
	name: 'SettingsSwitchField',
	props: {
		value: {
			type: [Boolean, String],
			default: false
		},
		labelText: {
			type: String,
			required: true
		},
		hintText: {
			type: String,
			default: null
		},
		disabled: {
			type: [Boolean, String],
			default: false
		}
	}
}
</script>

<style lang="scss" module>
.settings-switch-field {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 56px;
	width: 100%;
	padding: 16px;
	padding-bottom: $gutter * 2;
	border: 1px solid getColor(border);
	border-radius: 8px;
	background: getColor(surface-elevated);
	margin-bottom: $gutter;

	@include dark-mode-border-fix(border);

	&__content {
		display: flex;
		flex-direction: column;
		gap: 4px;
		padding-right: 12px;
	}

	&__label {
		font-size: 14px;
		line-height: 20px;
	}

	&__hint {
		font-size: 12px;
		line-height: 16px;
		color: getColor(sub-text);
	}
}
</style>
